import { useEffect } from "react";
import { Form } from "@circle-react-uikit/Form";
import { ChatForm } from "../../ChatForm";
import { ChatMessage } from "../../ChatMessage";
import { useChat } from "../../hooks/useChat";

export const ChatBotView = () => {
  const { messages, isUserInputEnabled, process } = useChat();

  useEffect(() => {
    if (messages.length == 0) {
      process({ event: "start-chat" });
    }
  }, [messages.length, process]);

  const onSubmit = event => {
    process({ event: "post-message", value: event.message });
  };

  return (
    <>
      <div className="mb-6 mt-auto flex flex-col">
        {messages.map(message => (
          <ChatMessage key={message.id} {...message} process={process} />
        ))}
      </div>
      {isUserInputEnabled ? (
        <div className="bg-primary sticky bottom-0 z-10">
          <div className="border-primary border-t">
            <Form onSubmit={onSubmit}>
              <ChatForm onSubmit={onSubmit} />
            </Form>
          </div>
        </div>
      ) : null}
    </>
  );
};
